import { Button } from "../../../../components";

interface SubmissionButtonsSectionProps {
  hasApprovedVendors: boolean;
  readyForSubmission: boolean;
  continuingWithoutPending: boolean;
  submittingDocuments: boolean;
  loanId: string;
  onContinueWithoutPending: () => Promise<void>;
  onSubmitDocuments: () => Promise<void>;
}

const SubmissionButtonsSection = ({
  hasApprovedVendors,
  readyForSubmission,
  continuingWithoutPending,
  submittingDocuments,
  onContinueWithoutPending,
  onSubmitDocuments,
}: SubmissionButtonsSectionProps) => {
  const isAnyActionInProgress = continuingWithoutPending || submittingDocuments;

  return (
    <div className="cx-w-full">
      <div className="cx-flex cx-flex-col sm:cx-flex-row cx-w-full cx-gap-3 sm:cx-gap-4">
        {hasApprovedVendors && (
          <Button
            label="Continue without pending vendors"
            loader={continuingWithoutPending ? "right" : undefined}
            fullWidth
            slim
            className="cx-whitespace-nowrap"
            onClick={onContinueWithoutPending}
            disabled={isAnyActionInProgress}
          />
        )}
        <Button
          label="Submit documents"
          disabled={!readyForSubmission || isAnyActionInProgress}
          fullWidth
          loader={submittingDocuments ? "right" : undefined}
          slim
          outlined={true}
          className="cx-whitespace-nowrap"
          onClick={onSubmitDocuments}
        />
      </div>
    </div>
  );
};

export default SubmissionButtonsSection;
